module.exports = __webpack_public_path__ + "static/assets/496c3c388ccd777c3b88b810fea5ff3d.svg";